import { useTheme } from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";

/**
 * Estado vazio dos dashboards, com a ilustração padrão do sistema.
 *
 * A `mensagem` é desenhada dentro do SVG (elemento <text>), que NÃO quebra
 * linha sozinho — passe o texto já quebrado com "\n", em linhas de até ~28
 * caracteres, senão ele vaza para fora da arte.
 */
export default function NoHostScreen({
  titulo = "Oops !",
  mensagem = "Nenhum host selecionado",
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Box sx={styles.container}>
      <ConfusedMale
        mainFill={theme.palette.secondary.dark}
        primaryCircleFill={theme.palette.secondary.main}
        highlightTitle={titulo}
        subtitle={mensagem}
      />
    </Box>
  );
}
